<template>
  <div class="imprint-detail">
    <div class="imprint-detail__left">
      <div class="imprint-detail__name">
        {{ imprintMethodModel.decorationMethod.Location }},
        {{ imprintMethodModel.decorationMethod.MappedMethod }}
      </div>
      <div class="imprint-detail__attr">
        <div class="imprint-detail__color table border">
          <dl
            class="table-tr"
            v-for="(color, index) in imprintMethodModel.decorationMethod
              .selectedColors"
            :key="index"
          >
            <dd class="table-td" style="width: 30px">
              <div
                class="color-thumb"
                :style="{ 'background-color': color.Color }"
              ></div>
            </dd>
            <dd class="table-td">
              <div class="color-name">{{ color.Name }}</div>
            </dd>
          </dl>
        </div>
        <div class="imprint-detail__artwork">
          <dd v-if="imprintMethodModel.decorationMethod.artworkType !== 1">
            <span class="tit">Artwork:</span>
            Email logo
          </dd>
          <dd v-if="imprintMethodModel.decorationMethod.artworkType === 1">
            <div
              class="imprint-detail__artwork-item"
              v-for="(artwork, idx) in imprintMethodModel.decorationMethod
                .selectedArtworkFiles"
              :key="idx"
            >
              <img :src="artwork.ThumbnailUrl" alt="" width="32" height="32" />
              <span class="artwork-fname">{{ artwork.FileName }}</span>
            </div>
          </dd>
          <dd class="artwork-notes">
            <div
              class=""
              v-html="imprintMethodModel.decorationMethod.customerNotes"
            ></div>
          </dd>
        </div>
      </div>
    </div>
    <div class="imprint-detail__btns">
      <button type="button" @click="onEdit">Edit</button>
      <button type="button" @click="onRemove">Delete</button>
    </div>
  </div>
</template>

<script lang="ts"></script>
<script setup lang="ts">
import { type PropType } from 'vue'
import { ImprintMethodModel } from '../../model';

const props = defineProps({
  imprintMethodModel: {
    type: Object as PropType<ImprintMethodModel>,
    default: {} as unknown
  },
  index: Number
})
const emit = defineEmits({
  edit: (index: number) => true,
  remove: (val: ImprintMethodModel) => true
})
const onEdit = () => {
  emit('edit', props.index!)
}
const onRemove = () => {
  emit('remove', props.imprintMethodModel)
}
</script>

<style lang="less">
.imprint-detail {
  position: relative;
  border: 1px solid #ccc;
  &__left {
    padding: 20px 80px 20px 24px;
    padding-left: 28px;
  }
  &__name {
    font-weight: bold;
    font-size: 15px;
    color: #999;
    width: 390px;
  }
  &__attr {
    padding-left: 12px;
    padding-top: 6px;
  }
  &__color {
    .table-tr {
      margin-bottom: 0;
    }
    .table-td {
      padding: 5px !important;
    }
    .color-thumb {
      border: 1px solid #ddd;
      width: 20px;
      height: 20px;
      font-size: 13px;
    }
    .color-name {
      word-break: break-word;
      font-size: 13px;
      vertical-align: super;
    }
  }
  &__artwork {
    padding-top: 5px;
    font-size: 13px;
    .tit {
      font-size: 13px;
      font-weight: 700;
      margin-top: 6px;
      color: #999;
    }
    .artwork-fname {
      padding-left: 5px;
      overflow-wrap: break-word;
      max-width: 400px;
      display: inline-block;
    }
    .artwork-notes {
      color: #4e4e4e;
      font-size: 13px;
      padding-left: 8px;
      margin-top: 5px;
    }
  }
  &__artwork-item {
    display: flex;
    align-items: center;
  }
  &__btns {
    position: absolute;
    top: 8px;
    right: 7px;
    button {
      background: transparent;
      outline: none;
      border: none;
      cursor: pointer;
      color: #4596ca;
      &:hover {
        box-shadow: none;
      }
      &:first-child {
        padding-right: 5px;
      }
    }
  }
}
@media (min-width: 991px) {
  .imprint-list {
    &__name {
      width: 390px;
    }
  }
}
</style>
